/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './verification.defs'
export { main as default } from './verification.defs'
